import styled from "styled-components";
import { STYLE_CONSTS } from "~/src/styles/config.style";

export const LoadingWrapper = styled.div`
  margin-top: ${STYLE_CONSTS.UNIT_4};
  display: flex;
  justify-content: center;
`;
